/* Publish by EComposer at 2026-10-21 18:40:47*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p6qj35urpqm"]=  window.__ectimmers["ecom-p6qj35urpqm"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-p6qj35urpqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6qj35urpqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ambwi52y8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ambwi52y8r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmsye528mz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmsye528mz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-evtk4sseacv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-evtk4sseacv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xr49mjjj76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xr49mjjj76', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7b7zmp4dh8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7b7zmp4dh8a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hm3pljr89jo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hm3pljr89jo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llq2fcuqmpk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llq2fcuqmpk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jk4x75emwp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jk4x75emwp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcoeqy1hdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcoeqy1hdj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sl1a39lghbd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sl1a39lghbd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y47ji2gs6za').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y47ji2gs6za', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wwmi7na7d6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wwmi7na7d6', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-kmve5jh8ny"]=  window.__ectimmers["ecom-kmve5jh8ny"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-kmve5jh8ny"]["b6rb2oeph"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-kmve5jh8ny').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmve5jh8ny', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qshalxsx1d"]=  window.__ectimmers["ecom-qshalxsx1d"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-qshalxsx1d"]["18ukzq4yk"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-qshalxsx1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qshalxsx1d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}